import { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, List, ListItem, Snackbar, SnackbarCloseReason, TextField } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { AutoCompleteFazenda, AutoCompleteProdutor, BasicSelect, IVFormErrors, SelectNumber, VFieldMoney, VForm, VSwitch, VTextField, VTextFieldNumber, useVForm } from '../../../shared/forms';
import * as yup from 'yup';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { EntradaService } from '../../../shared/services/api/estoque/entrada/EntradaService';
import { VFieldMoney4Faturamento } from './VFieldMoney4Faturamento';
import { useNavigate } from 'react-router-dom';

type NullableDate = Date | null | undefined;

interface IFormDataCabecalho {
  idparceiro: string;
  idplanoconta: string;
  idoperacoes: string;
  dataemissao: Date;
  numeronota: string;
  numerodoc: string;
  subtotal: number;
  desconto: number;
  outrasdespesas: number;
  totalnota: number;
  acrescimo: number;
  obs: string;

  cpf: string;
}

interface IitensEntradaDialog {
  iditens: string;
  idprod: string;
  idlocalizacao: string;
  qtdsaida: number;
  validade?: NullableDate;
  un: string;
  qtdentrada: number;
  conversor: number;
  preco: number;
  total: number;

  filtro: string;
  descricao: string;
  localizacao: string;
  reqvencimento: boolean;
}

interface IParcelasFaturamento {
  idcontaspagar: string;
  idparceiro: string;
  idplanoconta: string;
  idprodutor: number;
  dataemissao: Date;
  numerodoc: string;
  numeronfe: string;
  valornfe: number;
  valornota: number;
  historico: string;
  lcdpr: boolean;
  tipodoc: number;
  tipopagamento: string;
  historicolcdpr: string;
  vencimento: Date;
  valorparcela: number;
  nfeparcela: number;
  parcela: string;
  nfepago: number;
  nfepagar: number;
  valorpago: number;
  valorpagar: number;
  tipo: number;
  desconto: number;
  acrescimo: number;
  idfazenda: string;

  qtdParcela: number;
}

interface IItensids {
  iditens: string;
}


export interface ConfirmationDialogRawProps {
  id: string;
  value: string;
  open: boolean;
  status: boolean;
  operacao?: string;
  dados?: IFormDataCabecalho;
  dadosItens?: IitensEntradaDialog[];
  iddeletados?: IItensids[];
  onClose: (value?: string) => void; //
}

const formValidationSchema: yup.ObjectSchema<Omit<IParcelasFaturamento, 'idcontaspagar' | 'idparceiro' | 'idplanoconta' | 'nfeparcela' | 'nfepago' | 'valorpago' | 'dataemissao' | 'parcela' | 'valorparcela' | 'vencimento' | 'nfepagar' | 'valorpagar' | 'tipo' | 'desconto' | 'acrescimo'>> = yup.object().shape({
  idprodutor: yup.number().optional().default(0).when('lcdpr', {
    is: true,
    then: () => yup.number().required('Campo obrigatório')
  }),
  idfazenda: yup.string().required('Campo obrigatório'),
  numerodoc: yup.string().required(),
  numeronfe: yup.string().optional().default('').when('lcdpr', {
    is: true,
    then: () => yup.string().required('Campo obrigatório')
  }),
  valornfe: yup.number().optional().default(0).when('lcdpr', {
    is: true,
    then: () => yup.number().required('Campo obrigatório').moreThan(0)
  }),
  valornota: yup.number().required().moreThan(0),
  historico: yup.string().optional().default(''),
  lcdpr: yup.boolean().required().default(true),
  tipodoc: yup.number().optional().default(0).when('lcdpr', {
    is: true,
    then: () => yup.number().required('Campo obrigatório')
  }),
  tipopagamento: yup.string().required(),
  historicolcdpr: yup.string().optional().default('').when('lcdpr', {
    is: true,
    then: () => yup.string().required('Campo obrigatório')
  }),
  qtdParcela: yup.number().required().moreThan(0),
});

export const DialogFaturamento: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {
  const navigate = useNavigate();
  const { formRef, save, } = useVForm();
  const { onClose, value: valueProp, open, ...other } = props;
  const [, setValue] = useState(valueProp);
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState('');
  const [lista, setLista] = useState<IParcelasFaturamento[]>([]);
  const [, setAtualizarLista] = useState<{ idcontaspagar: string; valorparcela: number; }[]>([]);

  const itensnovo = {
    numerodoc: props.dados?.numerodoc,
    numeronfe: props.dados?.numeronota,
    valornfe: 0,
    valornota: props.dados?.totalnota,
    historico: props.operacao,
    lcdpr: true,
    tipopagamento: '',
    historicolcdpr: '',
    vencimento: '',
    qtdParcela: 1,
    intervalo: 0,
  };

  useEffect(() => {
    formRef.current?.setData(itensnovo);
    setQtdParcelas(1);
    setIntervalo(0);
  }, [id, formRef]);

  const [valornfe, setvalornfe] = useState(0);
  const [valornota, setvalornota] = useState(props.dados?.totalnota);
  const [idprodutor, setIdprodutor] = useState(0);
  const [qtdParcelas, setQtdParcelas] = useState(1);
  const [intervalo, setIntervalo] = useState(0);
  const [tipopagamento, setTipopagamento] = useState('');
  const [tipodoc, setTipodoc] = useState(0);
  const [historicolcdpr, sethistoricolcdpr] = useState('');
  const [lcdpr, setLcdpr] = useState<boolean>(true);
  const [fazenda, setFazenda] = useState('');
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
        
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if(tms === 'success'){ 
      onClose();
      navigate('/entradaestoque');
    }
  };

  const handleCancel = () => {
    onClose();
  };

  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    } else {
      setId(valueProp);
    }
    setvalornota(props.dados?.totalnota);
  }, [valueProp, open]);

  const handleVnfe = (valor: string | undefined) => {
    if (valor != null) {
      valor = valor.replace(/\./g, '');
      valor = valor.replace(/,/g, '.');
      valor = valor.replace(/(\d)(\d{4})$/, '$1.$2');
      valor = valor.replace(/(?=(\d{3})+(\D))\B/g, '');
      setvalornfe(Number(valor));
    }
  };

  const handleVnota = (valor: string | undefined) => {
    if (valor != null) {
      valor = valor.replace(/\./g, '');
      valor = valor.replace(/,/g, '.');
      valor = valor.replace(/(\d)(\d{4})$/, '$1.$2');
      valor = valor.replace(/(?=(\d{3})+(\D))\B/g, '');
      setvalornota(Number(valor));
    }
  };

  const handleIdProdutor = (valor: number | undefined) => {
    if (valor != null) {
      setIdprodutor(valor);

    }
  };

  const handleFazenda = (valor: string | undefined) => {
    if (valor != null) {
      setFazenda(valor);
    }
  };

  const handleQtdParcelas = (valor: string | undefined) => {
    if (valor != null) {
      setQtdParcelas(Number(valor));
    }
  };

  const handleIntervalo = (valor: string | undefined) => {
    if (valor != null) {
      setIntervalo(Number(valor));
    }
  };

  const handleTipopagamento = (valor: string | undefined) => {
    if (valor != null) {
      setTipopagamento(valor);
    }
  };

  const handleIdTipodoc = (valor: string | undefined) => {
    if (valor != null) {
      setTipodoc(Number(valor));
    }
  };

  const handlehistoricolcdpr = (valor: string | undefined) => {
    if (valor != null) {
      sethistoricolcdpr(valor);
    }
  };

  const handleLcdpr = (valor: boolean | undefined) => {
    if (valor != null) {
      setLcdpr(valor);
    }
  };

  useEffect(() => {
    setLista([]);
    const valorparcelanfe = valornfe! / qtdParcelas;
    const valorparcela = valornota! / qtdParcelas;
    const data = formRef.current?.getData();
    const numeronfe = data?.numeronfe;
    for (let i = 0; i < qtdParcelas; i++) {
      const dataVencimento = new Date();
      if (intervalo != 0) {
        dataVencimento.setDate(dataVencimento.getDate() + intervalo * i);
      } else {
        const newMonth = dataVencimento.getMonth() + i;
        dataVencimento.setMonth(newMonth);
      }
      const ops = (
        {
          idcontaspagar: uuidv4(),
          idparceiro: props.dados?.idparceiro || '',
          idplanoconta: props.dados?.idplanoconta || '',
          idprodutor: idprodutor,
          dataemissao: props.dados?.dataemissao || new Date(),
          numerodoc: props.dados?.numerodoc || '',
          numeronfe: numeronfe,
          valornfe: valornfe!,
          valornota: props.dados?.totalnota || 0,
          historico: props.operacao || '',
          lcdpr: lcdpr!,
          tipodoc: tipodoc,
          tipopagamento: tipopagamento,
          historicolcdpr: historicolcdpr,
          vencimento: dataVencimento,
          valorparcela: valorparcela,
          nfeparcela: valorparcelanfe,
          parcela: `${i + 1}/${qtdParcelas}`,
          nfepago: 0,
          valorpago: 0,
          nfepagar: valorparcelanfe, 
          valorpagar: valorparcela,
          tipo: 1,
          desconto: 0,
          acrescimo: 0,
          qtdParcela: 0, 
          idfazenda: fazenda
        });
      setLista((oldLista) => [...oldLista, ops]);
    }
  }, [
    valornota,
    tipopagamento,
    qtdParcelas,
    intervalo,
    valornfe,
    tipodoc,
    idprodutor,
    fazenda,
    historicolcdpr,
    lcdpr,
    open
  ]);

  const formatValue = (inputValue: string | number): string => {
    let formattedValue: string;

    if (typeof inputValue === 'number') {
      inputValue = inputValue.toString();
    }
    // Caso seja um número inteiro
    if (!inputValue.includes('.')) {
      formattedValue = inputValue.replace(/\D/g, ''); // Remove caracteres não numéricos
      formattedValue += ',0000'; // Adiciona a vírgula e 4 zeros
      formattedValue = formattedValue.replace(/(\d)(?=(\d{3})+(,))/g, '$1.'); // Adiciona pontos como separadores de mil
    } else {
      // Caso seja um número decimal
      formattedValue = inputValue.replace(/\./g, ','); // Substitui ponto por vírgula
      formattedValue = formattedValue.replace(/(\d+,\d{0,4})\d*/, '$1'); // Limita a 4 casas decimais
      formattedValue = formattedValue.replace(/(\d)(?=(\d{3})+(,))/g, '$1.'); // Adiciona pontos como separadores de mil
    }
    return formattedValue;
  };

  const handleSave = (dados: IParcelasFaturamento) => {

    const totalSum = lista.reduce((accumulator, currentItem) => accumulator + currentItem.valorparcela, 0);
    if (totalSum.toFixed(4) === props.dados?.totalnota.toFixed(4).toString()) {
      formValidationSchema
        .validate(dados, { abortEarly: false })
        .then(() => {
          setIsLoading(true);
          if (props.id === 'novo') {
            EntradaService.create(props.dados!, props.dadosItens!, lista).then((result) => {
              setIsLoading(false);
              if (result instanceof Error) {
                setTms('error');
                setMsg(result.message);
                setOpenmsg(true);
              } else {
                setTms('success');
                setMsg('Lançamento Realizado com sucesso!');
                setOpenmsg(true);
              }
            });
            setIsLoading(false);
          } else {
            EntradaService
              .updateById(props.id, props.dados!, props.dadosItens!, props.iddeletados!, lista)
              .then((result) => {
                setIsLoading(false);
                if (result instanceof Error) {
                  setTms('error');
                  setMsg(result.message);
                  setOpenmsg(true);
                } else {
                  setTms('success');
                  setMsg('Alteração concluída com sucesso!');
                  setOpenmsg(true);
                }
              });
          }
        })
        .catch((errors: yup.ValidationError) => {
          const validationErrors: IVFormErrors = {};
          errors.inner.forEach((error) => {
            if (!error.path) return;
            validationErrors[error.path] = error.message;
          });
          formRef.current?.setErrors(validationErrors);
        });
    } else {
      setTms('error');
      setMsg('Valor Total das Parçelas não Confere: R$ ' + formatValue(String(totalSum)));
      setOpenmsg(true);
    }
  };

  const handleInputChange = useCallback((id: string, valor: string) => {
    const updatedList = lista.map((listItem) => {
      if (listItem.idcontaspagar === id) {
        const novoObjeto = { idcontaspagar: id, valorparcela: Number(valor) };
        setAtualizarLista(prevLista => [...prevLista, novoObjeto]);
        return {
          ...listItem,
          valorpagar: Number(valor),
          valorparcela: Number(valor),
        };
      } else {
        return listItem;
      }
    });

    setLista(updatedList);
  }, [lista]);

  const handleInputChangeDate = useCallback((id: string, valor: Date) => {
    const updatedList = lista.map((listItem) => {
      if (listItem.idcontaspagar === id) {
        return {
          ...listItem,
          vencimento: valor,
        };
      } else {

        return listItem;
      }
    });
    setAtualizarLista(updatedList);
    setLista(updatedList);
  }, [lista]);

  return (
    <Dialog
      open={open}
      {...other}
      sx={{ width: '100%' }}
      maxWidth="md"
    >
      <DialogTitle>Faturamento</DialogTitle>
      <DialogContent dividers>
        <VForm ref={formRef} onSubmit={handleSave}>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
            <Alert
              onClose={handleCloseMsg}
              severity={tms}
              variant="filled"
              sx={{ width: '100%' }}
            >
              {msg}
            </Alert>
          </Snackbar>
          <Grid container direction="column" >
            <Grid container item direction="row"  >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item direction="row" padding={1} spacing={1.5} >
                  <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                    <BasicSelect
                      name='tipopagamento'
                      label='Forma de Pagamento'
                      data={[
                        { nameBD: 'Boleto', descricao: 'Boleto' },
                        { nameBD: 'Carteira', descricao: 'Carteira' },
                        { nameBD: 'Cartão Agro-Negocio', descricao: 'Cartão Agro-Negócio' },
                        { nameBD: 'Depósito', descricao: 'Depósito' },
                        { nameBD: 'Debito em conta', descricao: 'Débito em conta' },
                        { nameBD: 'pix', descricao: 'PIX' },
                      ]}
                      aoClicar={handleTipopagamento}
                      disabled={props.status === false ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VTextFieldNumber
                      fullWidth
                      size='small'
                      name='numerodoc'
                      label='Nº Documento'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='valornota'
                      label='Valor Nota'
                      calcular={handleVnota}
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={1.5} lg={1.5} xl={1.5}>
                    <VTextFieldNumber
                      fullWidth
                      size='small'
                      name='qtdParcela'
                      label='Qtd Parçela'
                      calcular={handleQtdParcelas}
                      disabled={props.status === false ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={1.5} lg={1.5} xl={1.5}>
                    <VTextFieldNumber
                      fullWidth
                      size='small'
                      name='intervalo'
                      label='Intervalo'
                      calcular={handleIntervalo}
                      disabled={props.status === false ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <AutoCompleteFazenda
                      isExternalLoading={props.status === false ? isLoading : true}
                      uuidfazenda={handleFazenda}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                    <AutoCompleteProdutor
                      isExternalLoading={props.status === false ? isLoading : true}
                      id={handleIdProdutor}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VTextFieldNumber
                      fullWidth
                      size='small'
                      name='numeronfe'
                      label='Nº NF-e'
                      disabled={props.status === false ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='valornfe'
                      label='Valor NF-e'
                      calcular={handleVnfe}
                      disabled={props.status === false ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <SelectNumber
                      name='tipodoc'
                      label='Tipo de Documento'
                      data={[
                        { nameBD: 1, descricao: 'Nota Fiscal' },
                        { nameBD: 2, descricao: 'Fatura' },
                        { nameBD: 3, descricao: 'Recibo' },
                        { nameBD: 4, descricao: 'Contrato' },
                        { nameBD: 5, descricao: 'Folha de Pagamento' },
                        { nameBD: 6, descricao: 'Outros' },
                      ]}
                      valor={handleIdTipodoc}
                      disabled={props.status === false ? isLoading : true}
                    />
                  </Grid>
                  
                  <Grid item xs={12} sm={12} md={10.5} lg={10.5} xl={10.5}>
                    <VTextField
                      fullWidth
                      size='small'
                      name='historicolcdpr'
                      label='Histórico LCDPR'
                      valor={handlehistoricolcdpr}
                      disabled={props.status === false ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={1.5} lg={1.5} xl={1.5}>
                    <VSwitch
                      size='small'
                      name='lcdpr'
                      label='LCDPR'
                      valor={handleLcdpr}
                      fdisabled={props.status === false ? isLoading : true} 
                      aliamento='top'
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </VForm>
        <List sx={{ pt: 0 }}>
          <DialogTitle>Parçelas</DialogTitle>
          {lista.map((listItem) => (
            <ListItem disableGutters key={listItem.idcontaspagar}>
              <Grid container direction="column" >
                <Grid container item direction="row"  >
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid container item direction="row" spacing={1} >
                      <Grid item xs={6.2} sm={3} md={3} lg={3} xl={3}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            format='DD/MM/YYYY'
                            value={dayjs(listItem.vencimento)}
                            label="Vencimento"
                            onChange={(newValue) => {
                              const inputValue = newValue!.toDate();
                              handleInputChangeDate(listItem.idcontaspagar, inputValue);
                            }}
                            slotProps={{
                              textField: {    
                                size:'small',
                              }
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={5.8} sm={3} md={3} lg={3} xl={3}>
                        <TextField
                          size='small'
                          value={listItem.numerodoc}
                          label="Nº Documento"
                        />
                      </Grid>
                      <Grid item xs={6} sm={3} md={3} lg={3} xl={3}>
                        <TextField
                          size='small'
                          value={listItem.parcela}
                          label="Nº Parcela"
                          disabled={true}
                        />
                      </Grid>
                      <Grid item xs={6} sm={3} md={3} lg={3} xl={3}>
                        <VFieldMoney4Faturamento
                          size='small'
                          id={listItem.idcontaspagar}
                          valor={handleInputChange}
                          label="Valor"
                          defaultValue={String(listItem.valorparcela.toFixed(4))}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' color='error' onClick={handleCancel}>Cancelar</Button>
        <Button variant='outlined' disabled={props.status === false ? isLoading : true} autoFocus onClick={save}>Confirmar</Button>
      </DialogActions>
    </Dialog>
  );
}; 